<script setup lang="ts">
import { RouterView } from 'vue-router';
import SiteHeader from '@/js/account/components/layout/SiteHeader.vue';
import ProfileBottomNav from '@/js/account/components/profile/ProfileBottomNav.vue';
import ProfileSidebar from '@/js/account/components/profile/ProfileSidebar.vue';
import { classNames } from '@/js/lib/bem';

const cn = classNames('profile-layout');
</script>

<template>
  <div :class="cn()">
    <SiteHeader :class="cn('site-header')" />
    <ProfileSidebar :class="cn('sidebar')" />
    <main :class="cn('main')">
      <RouterView />
    </main>
    <ProfileBottomNav :class="cn('bottom-nav')" />
  </div>
</template>

<style lang="scss" scoped>
.profile-layout {
  --profile-sidebar-width: 247px;
  --profile-bottom-nav-height: 77px;

  display: grid;
  grid-template-columns: var(--profile-sidebar-width) 1fr;
  min-height: 100vh;
  height: 100vh;
  background-color: var(--color-background-secondary);

  &__main {
    grid-column: 2;
    min-height: 0;
    overflow: auto;
  }

  &__sidebar {
    width: var(--profile-sidebar-width);
  }

  &__bottom-nav {
    height: var(--profile-bottom-nav-height);
    display: none;
  }

  &__site-header {
    display: none;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;

    &__site-header {
      display: block;
      grid-column: 1;
      grid-row: 1;
    }

    &__main {
      min-height: 0;
      padding-bottom: calc(var(--profile-bottom-nav-height) + env(safe-area-inset-bottom, 0px));
      grid-column: 1;
      grid-row: 2;
    }

    &__sidebar {
      display: none;
    }

    &__bottom-nav {
      display: block;
    }
  }
}
</style>
